import React from "react";
import {
    Card, CardGroup, CardBody, Button
} from "reactstrap";
import { faBox, faDownload, faGift, faReceipt, faTimes, faTv } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles/Subscription.scss";


const Subscription = (props) => {
    return (
        <React.Fragment>
            <div className="mt-4 close-button">
                <FontAwesomeIcon icon={faTimes} onClick={props.history.goBack} size="lg" className="icon" />
            </div>

            <div className="subscription-popup">
                <CardGroup className="container-fluid mt-2">
                    <Card>
                        <CardBody>
                            <div className="card-top">
                                <h2 className="title g5-pink">G5TV Basic Plan</h2>
                                <p className="offer g5-pink">10% off</p>
                            </div>
                            <div className="card-middle">
                                <p className="offer-info"><FontAwesomeIcon icon={faTv} size="lg" /> All new TV shows</p>
                                <p className="offer-info"><FontAwesomeIcon icon={faReceipt} size="lg" /> All new movies</p>
                                <p className="offer-info"><FontAwesomeIcon icon={faGift} size="lg" /> All new Reward Available</p>
                                <p className="offer-info"><FontAwesomeIcon icon={faBox} size="lg" /> All new Ad free entertainment</p>
                                <p className="offer-info"><FontAwesomeIcon icon={faDownload} size="lg" /> Unlimited Downloads</p>
                            </div>
                            <div className="card-bottom">
                                <p className="g5-pink">Get G5TV Basic Plan for <strike>$10</strike> $9/mo</p>
                                <Button color="primary" size="lg">Buy this plan</Button>
                            </div>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody>
                            <div className="card-top">
                                <h2 className="title g5-pink">G5TV Standard Plan</h2>
                                <p className="offer g5-pink">15% off</p>
                            </div>
                            <div className="card-middle">
                                <p className="offer-info"><FontAwesomeIcon icon={faTv} size="lg" /> All new TV shows</p>
                                <p className="offer-info"><FontAwesomeIcon icon={faReceipt} size="lg" /> All new movies</p>
                                <p className="offer-info"><FontAwesomeIcon icon={faGift} size="lg" /> All new Reward Available</p>
                                <p className="offer-info"><FontAwesomeIcon icon={faBox} size="lg" /> All new Ad free entertainment</p>
                                <p className="offer-info"><FontAwesomeIcon icon={faDownload} size="lg" /> Unlimited Downloads</p>
                            </div>
                            <div className="card-bottom">
                                <p className="g5-pink">Get G5TV Standard Plan for <strike>$10</strike> $9/mo</p>
                                <Button color="primary" size="lg">Buy this plan</Button>
                            </div>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody>
                            <div className="card-top">
                                <h2 className="title g5-pink">G5TV Premium Plan</h2>
                                <p className="offer g5-pink">25% off</p>
                            </div>
                            <div className="card-middle">
                                <p className="offer-info"><FontAwesomeIcon icon={faTv} size="lg" /> All new TV shows</p>
                                <p className="offer-info"><FontAwesomeIcon icon={faReceipt} size="lg" /> All new movies</p>
                                <p className="offer-info"><FontAwesomeIcon icon={faGift} size="lg" /> All new Reward Available</p>
                                <p className="offer-info"><FontAwesomeIcon icon={faBox} size="lg" /> All new Ad free entertainment</p>
                                <p className="offer-info"><FontAwesomeIcon icon={faDownload} size="lg" /> Unlimited Downloads</p>
                            </div>
                            <div className="card-bottom">
                                <p className="g5-pink">Get G5TV Premium Plan for <strike>$10</strike> $9/mo</p>
                                <Button color="primary" size="lg">Buy this plan</Button>
                            </div>
                        </CardBody>
                    </Card>
                </CardGroup>
                <style>{`
           ${!props.match.params.userId ? "" : "body .app-bar-container{display: none;}"}
        `}</style>
            </div>
        </React.Fragment>
    );
};

export default Subscription;
